// Home client (plan §4 GET /home, spec F2).
import type { Http } from './http.ts';
import { homeSchema, type Home } from './schemas/home.ts';

export * from './schemas/home.ts';

export interface HomeApi {
  get(signal?: AbortSignal): Promise<Home>;
}

export function createHomeApi(http: Http): HomeApi {
  return { get: (signal) => http.json({ method: 'GET', path: '/home', signal }, homeSchema) };
}
